<template>
  <div class="part-inventory-bd tb" v-if="funcView.parts_inventory_list" style="padding: 0">
    <custom-tab v-model="tab" :list="tabList"></custom-tab>
    <stock v-if="tab === '2'"></stock>
    <unstock v-if="tab === '3'"></unstock>
  </div>
</template>

<script>
import stock from './children/part_inventory_stock.vue';
import unstock from './children/part_inventory_unstock.vue';

export default {
  mixins: [],
  components: { stock, unstock },
  name: 'partInventory',
  data() {
    return {
      provide: true,
      tab: '2',
    };
  },
  computed: {
    tabList() {
      return [
        {
          name: this.$t('dms_part_inventory.yi_ru_ku'),
          value: '2',
        },
        {
          name: this.$t('dms_part_inventory.yi_chu_ku'),
          value: '3',
        },
      ];
    },
  },
  mounted: function () {
    this.getFuncView();

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';

</style>
